/**
 * Centralized constants for the SOAR frontend application.
 */

export const APP_CONFIG = {
  API_PORT: 8026,
  BASE_URL: '/api/v1',
};

export const API_ROUTES = {
  PLAYBOOKS: `${APP_CONFIG.BASE_URL}/playbooks`,
  AUTOMATION: `${APP_CONFIG.BASE_URL}/automation`,
  CATALOG: `${APP_CONFIG.BASE_URL}/catalog`,
};
